import * as React from 'react';

export const LazyElevatedRiskPreserveCapitalExclusion = React.lazy(() => import('./component'));
